import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const MentionIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Mention",
    children: /*#__PURE__*/_jsx("path", {
      d: "M29.21 8.28c-.5-1.19-1.27-2.22-2.21-3.1-.98-.85-2.14-1.52-3.48-1.99-1.34-.46-2.87-.7-4.56-.7-2.35 0-4.53.36-6.59 1.06-2.06.72-3.88 1.76-5.4 3.1a14.2 14.2 0 0 0-3.64 4.93c-.9 1.94-1.32 4.1-1.32 6.53 0 1.68.26 3.23.79 4.65.55 1.39 1.32 2.61 2.35 3.59 1.03 1.01 2.27 1.78 3.74 2.32 1.45.57 3.11.83 4.93.83.87 0 1.66-.05 2.43-.18.76-.13 1.58-.34 2.45-.67.9-.31 1.95-.77 3.19-1.39l-1.16-2.09c-.79.41-1.53.77-2.19 1.03-.66.28-1.32.49-2.06.65-.71.13-1.56.18-2.56.18-1.48 0-2.79-.18-3.95-.59s-2.14-1.01-2.9-1.78c-.79-.8-1.37-1.73-1.79-2.84s-.63-2.37-.63-3.79c0-2.04.34-3.87 1-5.47.69-1.63 1.63-2.99 2.85-4.1 1.24-1.14 2.74-1.99 4.48-2.58 1.77-.59 3.69-.88 5.85-.88 1.79 0 3.32.28 4.61.88 1.27.59 2.24 1.45 2.93 2.53.66 1.11 1 2.45 1 4 0 1.03-.11 2.04-.34 2.99-.24.96-.55 1.78-.95 2.53-.4.72-.87 1.29-1.42 1.73-.55.41-1.13.62-1.77.62-.29 0-.53-.08-.76-.21-.24-.1-.4-.31-.53-.57-.11-.26-.13-.59-.08-.98L23.13 9h-3.19l-.34 2.19c-.05-.26-.16-.49-.29-.72-.34-.54-.76-.98-1.27-1.29-.53-.31-1.11-.46-1.77-.46-1.13 0-2.14.26-3.06.77-.95.52-1.74 1.19-2.43 2.01-.66.83-1.19 1.73-1.53 2.71-.37 1.01-.55 1.99-.55 2.97 0 1.11.21 2.09.61 2.92.4.85.95 1.52 1.66 1.99.71.49 1.5.72 2.43.72.84 0 1.61-.18 2.35-.54.71-.34 1.34-.85 1.87-1.52.21-.26.4-.57.55-.88.03.57.18 1.06.47 1.5.32.44.76.8 1.32 1.06.55.26 1.21.39 1.92.39 1.16 0 2.21-.28 3.19-.85s1.85-1.34 2.58-2.32c.74-.98 1.32-2.12 1.71-3.38.42-1.26.63-2.61.63-4s-.26-2.76-.79-3.95Zm-10.28 6.4c-.05.26-.11.57-.16.96-.11.75-.4 1.45-.87 2.14s-1.05 1.26-1.71 1.7-1.37.67-2.08.67c-.66 0-1.19-.26-1.58-.75-.4-.52-.58-1.21-.58-2.12 0-.96.18-1.91.58-2.81.42-.93.95-1.68 1.63-2.27.66-.59 1.42-.88 2.24-.88.53 0 .98.1 1.37.31s.69.49.9.88.32.85.32 1.39c0 .23-.03.49-.05.77Z"
    })
  }));
};